module.exports = __webpack_public_path__ + "static/community-ambassadors-photo-d5435ac773e20b4cef102c03e08b7dd2.jpg";